const shouldShow = (editor) => {
  const { state, view } = editor;
  const { selection } = state;
  const { $anchor, empty } = selection;
  const isRootDepth = $anchor.depth === 1;
  const isEmptyTextBlock =
    $anchor.parent.isInline ||
    ($anchor.parent.isTextblock && !$anchor.parent.type.spec.code && !$anchor.parent.textContent);

  const hasPlaceholder = document.querySelector('p.is-empty');
  if (!hasPlaceholder || !view.hasFocus() || !empty || !isRootDepth || !isEmptyTextBlock || !editor.isEditable) {
    return false;
  }

  return true;
};

export default shouldShow;
